import * as types from "../actions/types";



const initialState = {
  list:[]
};


export default function educationalMethodologicalKits (state = initialState, action) {
  switch (action.type) {
    case types.GET_EMK_LIST:
      return {
        ...state,
        list: action.payload,
      };
    case types.GET_LIST_MODAL_TAB_EMK:
      return {
        ...state,
        listTab: action.payload,
      };
  
    default:
      return state;
  }
}